import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NumberFormatService {
    // Cache formatters by locale + options so each Intl.NumberFormat is constructed once and reused.
    private _formatters = new Map<string, Intl.NumberFormat>();

    format(value: number | string | null | undefined, options: Intl.NumberFormatOptions = {}, locale = 'en-US'): string {
        const parsed = this.parse(value);

        if (parsed === null) {
            return '';
        }

        return this.getFormatter(options, locale).format(parsed);
    }

    parse(value: number | string | null | undefined): number | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const parsed = Number(String(value).replace(/,/g, ''));
        return isNaN(parsed) ? null : parsed;
    }

    round(value: number | string | null | undefined, options: Intl.NumberFormatOptions = {}, locale = 'en-US'): number | null {
        const parsed = this.parse(value);

        if (parsed === null) {
            return null;
        }

        const rounded = Number(this.getFormatter({ ...options, useGrouping: false }, locale).format(parsed));
        return isNaN(rounded) ? parsed : rounded;
    }

    private getFormatter(options: Intl.NumberFormatOptions, locale: string): Intl.NumberFormat {
        const key = `${locale}:${JSON.stringify(options)}`;
        let formatter = this._formatters.get(key);

        if (!formatter) {
            formatter = new Intl.NumberFormat(locale, options);
            this._formatters.set(key, formatter);
        }

        return formatter;
    }
}
